module.exports = __webpack_public_path__ + "static/media/build.7f44bfda.svg";